import { render, staticRenderFns } from "./addCountry.vue?vue&type=template&id=05bc6ee8"
import script from "./addCountry.vue?vue&type=script&lang=js"
export * from "./addCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports